function getErrors(formValues) {
  let errors = {
    cardNumber: '',
    name: '',
    address1: '',
    city: '',
    state: '',
    postalCode: '',
    expMonth: '',
    expYear: '',
    cvv: '',
    addressBlock: ''
  };

  if (formValues.cardNumber == '') {
    errors.cardNumber = 'Card number is required';
  }

  if (formValues.name == '') {
    errors.name = 'Name on card is required';
  }

  if (formValues.internationalAddress) {
    if (formValues.addressBlock == '') {
      errors.addressBlock = 'If billing address outside US, Canada, or Puerto Rico, address block is required';
    }
  } else {
    if (formValues.address1 == '') {
      errors.address1 = 'Address Line 1 is required';
    }
  
    if (formValues.city == '') {
      errors.city = 'City is required';
    }
  
    if (formValues.state == '') {
      errors.state = 'State is required';
    }
  
    if (formValues.postalCode == '') {
      errors.postalCode = 'Postal Code is required';
    }
  }

  if (formValues.expMonth == '') {
    errors.expMonth = 'Expiration month is required';
  }

  if (formValues.expYear == '') {
    errors.expYear = 'Expiration year is required';
  }

  if (formValues.cvv == '') {
    errors.cvv = 'CVV is required';
  }

  const noErrors = Object.values(errors).every(value => {
    return value === '';
  });

  if (noErrors) {
    return null;
  } else {
    return errors;
  }
}

export default getErrors;